{
  "name": "sharelog-frontend",
  "version": "1.0.0",
  "engines": {
    "node": ">=24.15.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --hmr --configuration local",
    "start:dev": "ng serve --hmr --configuration dev",
    "start:int": "ng serve --hmr --configuration int",
    "build": "ng build --named-chunks",
    "build:prod": "ng build --configuration production",
    "build:gm1": "ng build --configuration gm1",
    "build:gm2": "ng build --configuration gm2",
    "build:regie": "ng build --configuration regie",
    "build:int": "ng build --configuration int",
    "build:dev": "ng build --configuration dev",
    "test": "ng test",
    "lint": "ng lint",
    "prepare": "husky",
    "pre-commit": "npx lint-staged && npm run lint && npm run build",
    "source-map-explorer": "ng run sharelog-frontend:analyze",
    "generate-i18n-csv": "node tools/i18n/generate-csv-lang-file",
    "update-i18n-files": "node tools/i18n/update-language-files"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/material": "^22.2.5",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@angular/service-worker": "^22.2.4",
    "@auth0/angular-jwt": "^5.2.0",
    "@babel/runtime": "^7.26.0",
    "@ericblade/quagga2": "^1.8.4",
    "@infragistics/igniteui-angular": "^22.2.4",
    "@microsoft/signalr": "^8.0.7",
    "@ngneat/overview": "^8.1.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@ngxpert/hot-toast": "^7.0.0",
    "@zoom/meetingsdk": "^4.0.7",
    "angular-gridster2": "^22.0.0",
    "angularx-qrcode": "^22.0.1",
    "bingmaps": "^2.0.3",
    "bootstrap": "^4.6.2",
    "core-js": "^3.39.0",
    "hammerjs": "^2.0.8",
    "igniteui-angular-charts": "^22.0.1",
    "igniteui-angular-core": "^22.0.1",
    "igniteui-theming": "^28.1.1",
    "jquery": "^3.7.1",
    "jquery-migrate": "^3.5.2",
    "jquery-ui": "^1.14.1",
    "jszip": "^3.10.1",
    "jwt-decode": "^4.0.0",
    "marked": "^18.0.12",
    "marked-smartypants": "^1.1.10",
    "ngx-markdown": "^22.0.2",
    "perfect-scrollbar": "^1.5.6",
    "popper.js": "^1.16.1",
    "resize-observer-polyfill": "^1.5.1",
    "rxjs": "~7.8.2",
    "signalr": "^2.4.3",
    "sweetalert2": "^11.22.5",
    "tinycolor2": "^1.6.0",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "video.js": "^8.23.4",
    "zone.js": "^0.16.3"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.6.0",
    "@angular-eslint/eslint-plugin": "^22.6.0",
    "@angular-eslint/eslint-plugin-template": "^22.6.0",
    "@angular-eslint/schematics": "^22.6.0",
    "@angular-eslint/template-parser": "^22.6.0",
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@angular/language-service": "^22.2.4",
    "@eslint/compat": "^1.3.2",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.35.0",
    "@igniteui/angular-schematics": "^22.2.1582",
    "@ngx-builders/analyze": "^4.0.0",
    "@stylistic/eslint-plugin": "^5.3.1",
    "@types/jquery": "^3.5.33",
    "@types/node": "^24.3.0",
    "@types/signalr": "^2.4.3",
    "@types/tinycolor2": "^1.4.6",
    "@types/uuid": "^10.0.0",
    "@types/video.js": "^7.3.58",
    "@typescript-eslint/eslint-plugin": "^8.70.0",
    "@typescript-eslint/parser": "^8.70.0",
    "@typescript-eslint/utils": "^8.70.0",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "^22.6.0",
    "eslint": "^9.28.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^54.1.1",
    "eslint-plugin-no-null": "^1.0.2",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-unused-imports": "^4.2.0",
    "husky": "^9.1.6",
    "igniteui-angular-i18n": "^22.2.4",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "lint-staged": "^16.1.6",
    "prettier": "^3.6.2",
    "prettier-plugin-organize-imports": "^4.2.0",
    "sass-loader": "^16.0.3",
    "shelljs": "^0.10.0",
    "ts-node": "~10.9.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.70.0",
    "vitest": "^4.1.11"
  },
  "lint-staged": {
    "*.{js,ts,css,scss,html,md,json,yml,mjs}": "prettier --write"
  }
}
